import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { httpOptions } from 'src/app/submodules/angular-common/http-util';
import { buildUrl } from 'submodules/engine-common/util';
import { fileTransfer, FileTransfer } from 'src/app/submodules/angular-common/util';

@Injectable()
export class SignUpStep1Service {

    constructor(
        private _injector: Injector,
        private _httpClient: HttpClient,
    ) { }


    requireSignUpObs(firstName, lastName, email, application, recaptchaToken?): Observable<any> {

        return this._httpClient.post(
            buildUrl(this._injector.get(EnvironmentDataService).environment.getValue("endpoints.authApi"),
                ["v1", "require-sign-up"]),
            {
                'first-name': firstName,
                'last-name': lastName,
                'email': email,
                'application': application,
                'recaptcha-token': recaptchaToken
            })
    }


    requireSignUp = async (firstName, lastName, email, application, recaptchaToken?): Promise<any> => this.requireSignUpObs(firstName, lastName, email, application, recaptchaToken).toPromise()

}
